import React, {Component} from 'react';
import TextInput from '../TextInput';
import CustomButton from '../CustomButton';
import styles from './Login.module.css';
import {SITE} from '../../../../shared/constants/URLs';

// SVGs
import AppLogo from '../../../../shared/project-info/svgs-web/AppLogo.js';

import {isNullOrEmpty, validateEmail} from '../../../../shared/utils/Helpers';
import {rwbApi} from '../../../../shared/apis/api';
import Loading from '../Loading';
import {logForgotPassword, logLogin} from '../../../../shared/models/Analytics';
import {INVALID_LOGIN_ERROR} from '../../../../shared/constants/ErrorMessages';
import ApiInfo from '../ApiInfo';
import { projectConfig } from '../../../../shared/project-info/projectConfig';
import { authentication } from '../../../../shared/models/Authentication';
import { userProfile } from '../../../../shared/models/UserProfile';
import registerProfileFlow from '../../../../shared/utils/RegisterProfileFlow';


export default class Login extends Component {

  constructor(props) {
    super(props);
    const useSingleSignOn = window.location.pathname.includes("/callback");
    this.state ={
      value: 0,
      email: '',
      password: '',
      email_error_text: null,
      password_error_text: null,
      isLoading: false,
      useSingleSignOn: useSingleSignOn,
    };
  }
  
  navigateForUser = (json) => {
    const { history, location } = this.props;
    const { email_verified, profile_completed, workspace } = json;
    if (!email_verified) {
      history.push(`/registration/confirm_email`);
    } else if (projectConfig.hasWorkspaces && workspace == null && !userProfile?.isOperator) {
      history.push(`/registration/work_space`);
    } else if (email_verified && !profile_completed) {
      const firstScreen = registerProfileFlow.getFirstScreen();
      history.push(`/registration/${firstScreen.path}`);
    } else {
      let referrer = location?.state?.referrer;
      if (referrer) {
        referrer = referrer.replace(window.location.origin, '');
        referrer = referrer.replace(window.port, '');
        history.replace(referrer);
      } else {
        history.replace('/feed');
      }
    }
  }

  async componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("code");
    const state_ = params.get("state");
    if (token !== null && state_ !== null) {
      this.setState({isLoading: false});
      rwbApi.getAuthentikToken(token, state_)
      .then((json) => {
        this.navigateForUser(json);
      })
      .catch((error) => {
        console.warn(error);
        this.setState({
          password_error_text: INVALID_LOGIN_ERROR.toUpperCase(),
          isLoading: false,
        });
      });
    }
  }

  valueChangeHandler = (event, field) => {
    this.setState({[field]: event.target.value});
  };

  clearErrors() {
    this.setState({
      email_error_text: '',
      password_error_text: '',
    });
  }

  loginHandler = () => {
    logLogin();
    let {email, password} = this.state;

    this.clearErrors();
    let hasError = false;

    if (isNullOrEmpty(email) || !validateEmail(email)) {
      this.setState({email_error_text: 'PLEASE ENTER A VALID EMAIL'});
      hasError = true;
    }
    if (!hasError && this.state.useSingleSignOn) {
      this.setState({isLoading:true});
      rwbApi.getAuthentikRedirect(email).then((result) => { 
        // Potential for this to be window.open instead. My provide some UX
        // improvements down the line.
        window.location.href = result.redirect_uri;
      }).catch((error) => {
        this.setState({
          isLoading: false,
          email_error_text: error.message.toUpperCase()
        });
      });
      return;
    }
    if (!password || password === null || password === '') {
      this.setState({password_error_text: 'ENTER YOUR PASSWORD'});
      hasError = true;
    }

    if (hasError) {
      return;
    }

    this.setState({
      email: email.trim(),
      isLoading: true,
    });
    rwbApi
      .loginUser(email, password)
      .then((json) => {
        this.setState({isLoading: false});
        this.navigateForUser(json);
      })
      .catch((error) => {
        console.warn(error);
        this.setState({
          password_error_text: INVALID_LOGIN_ERROR.toUpperCase(),
          isLoading: false,
        });
      });
  };
  toggleSingleSignOn = () => {
    this.setState({
      useSingleSignOn: !this.state.useSingleSignOn
    })
  }

  contactUs = () => {
    window.open(`mailto:${projectConfig.supportEmail}`)
  }

  render() {
    const {
      email,
      password,
      email_error_text,
      password_error_text,
      isLoading,
    } = this.state;
    const allowSingleSignOn = projectConfig.hasOktaAuthentication;
    return (
      <>
        <Loading size={100} color={'var(--white)'} loading={isLoading} />
        <div className="fullScreenContainer">
          <center>
            <AppLogo key="login-logo" id="login-logo" className={styles.logo} />
          </center>
          <TextInput
            label={'Email'}
            type={'text'}
            value={email}
            onValueChange={(event) => this.valueChangeHandler(event, 'email')}
            error={email_error_text}
            onEnter={this.loginHandler}
          />
        {!this.state.useSingleSignOn &&  <TextInput
            label={'Password'}
            type={'password'}
            value={password}
            onValueChange={(event) =>
              this.valueChangeHandler(event, 'password')
            }
            error={password_error_text}
            onEnter={this.loginHandler}
          />
          }
          {!this.state.useSingleSignOn ? <p className={styles.forgotPasswordText}>
            Forgot your password?{' '}
            <a
              className="link"
              onClick={logForgotPassword}
              href={SITE.lostpassword}>
              Click Here
            </a>
          </p> :

            <p className={styles.forgotPasswordText}> Enter the email that you use for your organization's SSO. Having trouble?  <a
              className="link"
              onClick={this.contactUs}
            >
              Contact us
            </a></p>
          }
          <CustomButton
            label="Sign In"
            buttonStyle="primary"
            onClick={this.loginHandler}
          />
          {allowSingleSignOn &&
            <>
              {!this.state.useSingleSignOn && <CustomButton
                label="Sign In With SSO"
                buttonStyle="primary"
                onClick={this.toggleSingleSignOn}
              />}
            </>
          }
          {this.state.useSingleSignOn ?
            <CustomButton
              buttonStyle="secondary"
              label="RETURN TO SIGN IN"
              onClick={this.toggleSingleSignOn}
            />
        :  <CustomButton
            link={true}
            to="/registration"
            label="Create Account"
            buttonStyle="secondary"
          />}
          <ApiInfo />
        </div>
      </>
    );
  }
}

